import { gql } from 'graphql-tag'
import fragmentModuleNavigationLink from '../../modules/module-navigation-link/fragment-module-navigation-link'
import fragmentModuleMedia from '../../modules/module-media/fragment-module-media'
import fragmentModuleVideo from '../../modules/module-video/fragment-module-video'
import fragmentModuleInternalVideo from '../../modules/module-internal-video/fragment-module-internal-video'
import fragmentGlobalDataTheme from '../../global-data/global-data-theme/fragment-global-data-theme'

export default gql`
  ${fragmentGlobalDataTheme}
  ${fragmentModuleMedia}
  ${fragmentModuleVideo}
  ${fragmentModuleInternalVideo}
  ${fragmentModuleNavigationLink}
  fragment BlockLandscapeMediaThenContentFragment on BlockLandscapeMediaThenContent {
    sys {
      id
    }
    title
    blockLandscapeMediaThenContentDescription: description {
      json
    }
    media {
      ... on ModuleMedia {
        contentType: __typename
        ...ModuleMediaFragment
      }
      ... on ModuleVideo {
        contentType: __typename
        ...ModuleVideoFragment
      }
      ... on ModuleInternalVideo {
        contentType: __typename
        ...ModuleInternalVideoFragment
      }
    }
    link {
      ...ModuleNavigationLinkFragment
    }
    sectionTheme {
      ...GlobalDataThemeFragment
    }
  }
`
